<template>
  <div class="grid content-start">
    <div class="w-full z-[10]">
      <div class="text-generator-input-box-step">
        <div class="grid gap-2 mt-3">
          <ReferenceSearchInput tooltip="Provide a keyword or phrase." label="Search by Sentence, Keyword, or Phrase"
            placeholder="Type keyword or phrase here" v-model="phrase" />
          <ReferenceSearchInput tooltip="Provide an author." label="Search by Author"
            placeholder="Type full author's name here" v-model="author" />
        </div>
        <div class="w-full mt-3 mb-3">
          <div>
            <v-btn :disabled="!(phrase || author || journal) || loadingResponse" :loading="loadingResponse"
              @click="handleReferenceSearch()" variant="flat"
              class="!py-3 w-full !bg-primary-main !ml-auto !rounded-xl !tracking-normal !capitalize !text-white !h-auto">
              Search
              <template v-slot:append>
                <Icon icon="mdi:search" class="text-xl" />
              </template>
            </v-btn>
          </div>
        </div>
      </div>


    </div>
    <div v-if="references?.length">
      <span class="font-bold text-base mt-4 mb-2">Results</span>
      <div class="w-full h-0.5 bg-black/10 shadow-[0_2px_5px_rgba(0,0,0,0.2)] z-[15]" />
      <div class="grid gap-2">
        <div class="relative w-full grid gap-2 flex-1 h-96">
          <div class="py-5 overflow-y-auto overflow-x-hidden" ref="chatContainer">
            <div class="whitespace-normal w-full break-words mb-3">
              <div v-for="(reference, index) in references" :key="index">
                <div class="flex justify-start mb-8">
                  <div class="grid grid-cols-4 gap-0">
                    <div
                      class="col-span-3 bg-white py-2 px-4 ml-0 -mr-24 rounded-xl h-fit max-w-md relative cursor-pointer">
                      <p class="text-sm whitespace-pre-line" v-html="reference.html"></p>
                    </div>
                    <div class="flex items-center justify-center cursor-pointer ml-24 copy-reference"
                      :data-clipboard-text="reference.plain">
                      <Icon icon="ant-design:copy-outlined" class="text-4xl text-grey" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InfiniteLoading @infinite="handleReferenceSearch">
              <template #spinner>
                <span class="items-center align-center">loading...</span>
              </template>
            </InfiniteLoading>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TlTextArea from '@/components/global/TlTextArea.vue';
import ReferenceSearchInput from '@/components/home/referenceSearch/ReferenceSearchInput.vue';
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';
import Message from 'antd-message';
import ClipboardJS from 'clipboard';
import { referenceSearch } from '@/actions/functions';
import queryString from 'querystring';
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";

@Options({
  components: {
    TlTextArea,
    ReferenceSearchInput,
    InfiniteLoading,
    Icon
  }
})
export default class ReferenceSearch extends Vue {
  mounted() {
    const clipboard = new ClipboardJS('.copy-reference');

    clipboard.on('success', function (e) {
      Message.success('Reference copied to clipboard');
      e.clearSelection();
    });

    clipboard.on('error', function (e) {
      Message.error('Reference could not be copied. Please try again.');
    });
  }

  @Prop()
  tour!: any;

  public author = '';
  public journal = '';
  public phrase = '';
  public loadingResponse = false;
  private payloadStore = usePayloadStore();
  public references: any = [];
  public cursor: any = [];

  public handleReferenceSearch($state: any = '') {

    const payload: any = { author: this.author, phrase: this.phrase, journal: this.journal };
    if ($state) payload.cursor = this.cursor;
    else payload.cursor = '*';
    this.payloadStore.change({ loadingBrainResponse: true });
    this.loadingResponse = true;
    referenceSearch((new URLSearchParams(JSON.parse(JSON.stringify(payload)))).toString())
      .then((res: any) => {
        if (res?.data?.data?.length <= 0) {
          if (!$state) Message.error('No results found. Please try again.');
          else $state.complete();
        }
        else {
          if ($state) {
            this.references.push(...res.data.data);
            $state.loaded();
          } else {
            this.references = res.data.data;
          }
        }
        this.cursor = res.data?.meta?.cursor;
        this.payloadStore.change({ loadingBrainResponse: false });
        this.loadingResponse = false;
      })
      .catch((err) => {
        Message.error('Could not fetch references. Please try again.');
        this.payloadStore.change({ functionError: true });
        this.payloadStore.change({ loadingBrainResponse: false });
        this.loadingResponse = false;
        $state && $state.error();
      });
  }

  public insertSentence(sentence: string) {
    this.$emit('insertSentence', sentence);
  }
}
</script>
<style>
@keyframes bounceColors-1 {

  0%,
  50% {
    background-color: #9ad0ff;
  }

  25% {
    background-color: #5db0ff;
  }

  75% {
    background-color: #3995ff;
  }
}

@keyframes bounceColors-2 {

  0%,
  50% {
    background-color: #3995ff;
  }

  25% {
    background-color: #9ad0ff;
  }

  75% {
    background-color: #5db0ff;
  }
}

@keyframes bounceColors-3 {

  0%,
  50% {
    background-color: #5db0ff;
  }

  25% {
    background-color: #3995ff;
  }

  75% {
    background-color: #9ad0ff;
  }
}

.animate-bounce-blue-1 {
  animation: bounceColors-1 3s infinite;
}

.animate-bounce-blue-2 {
  animation: bounceColors-2 3s infinite;
}

.animate-bounce-blue-3 {
  animation: bounceColors-3 3s infinite;
}
</style>
